export const convertPrice = (price: number): string => {
  return price.toFixed(2) + '€';
}
